var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPath5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 410,
    height: 15,
    viewBox: "0 0 410 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7098 5.61173C147.518 -0.52886 271.484 -0.278609 391.818 5.52326C414.738 6.62836 346.02 8.69921 323.074 9.15421C284.96 9.90998 246.828 9.43165 208.706 9.15421C204.761 9.1255 200.856 8.31778 196.912 8.23603C164.397 7.56211 131.866 7.65012 99.353 6.88771C81.1238 6.46025 62.9289 5.10211 44.7 4.66675C31.9245 4.36162 19.139 4.47663 6.36094 4.66675C4.67738 4.69179 -0.326678 5.29502 1.357 5.3116C46.6664 5.75793 91.9956 4.81205 137.291 5.9565C156.521 6.44237 175.611 9.28586 194.823 10.1998C268.8 13.7188 336.24 15.8029 408.993 10.2581",
    stroke: "#2350F1",
    strokeWidth: 1.57316
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath5);
export default __webpack_public_path__ + "static/media/path-5.c316946cdb808efda8525a427df58c44.svg";
export { ForwardRef as ReactComponent };